import { Component, OnInit, AfterViewInit, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HomeComponent implements OnInit, AfterViewInit, OnDestroy {

  modalAberto = false;
  guiaMockup = false;
  sliderValue = 50;
  faqAberto: number | null = null;

  private commentObserver!: IntersectionObserver;

  faqItems = [
    {
      pergunta: 'O Mister Contador substitui um ERP?',
      resposta: 'Não. O Mister Contador complementa o seu ERP. Ele organiza extratos, notas fiscais e comprovantes e entrega lançamentos contábeis estruturados, prontos para importação no seu ERP.'
    },
    {
      pergunta: 'O Mister Contador é um conversor de dados?',
      resposta: 'Não. O Mister não apenas converte arquivos. Ele captura, organiza e cruza os insumos contábeis com base documental, estruturando os lançamentos com consistência.'
    },
    {
      pergunta: 'Como posso saber se o Mister Contador é adequado para o meu escritório?',
      resposta: 'Se hoje sua equipe perde tempo organizando extratos, notas fiscais e comprovantes, o Mister Contador já resolve um dos principais gargalos da operação contábil.'
    },
    {
      pergunta: 'O Mister Contador funciona com qualquer sistema contábil?',
      resposta: 'O Mister Contador é compatível com os principais ERPs contábeis do mercado, com exportação de lançamentos em formato adequado para importação. Caso o seu sistema não esteja na lista, existe um processo técnico de homologação para validação.'
    },
    {
      pergunta: 'Preciso de conhecimento técnico para usar o Mister?',
      resposta: 'A plataforma foi desenvolvida para uso prático na rotina contábil, com apoio de onboarding e suporte durante a implantação.'
    },
    {
      pergunta: 'Como o Mister reduz a dependência do cliente?',
      resposta: 'Com as integrações ativas, o Mister captura extratos, comprovantes e notas fiscais diretamente nas fontes, reduzindo a necessidade de solicitar e organizar documentos manualmente.'
    }
  ];

  toggleFaq(index: number): void {
    this.faqAberto = this.faqAberto === index ? null : index;
    this.cdr.markForCheck();
  }

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    this.commentObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach(e => {
          if (e.isIntersecting) {
            e.target.querySelectorAll('.comment').forEach(c => c.classList.add('visible'));
          }
        });
      },
      { threshold: 0.15 }
    );
    const hero3 = document.querySelector('.hero-3');
    if (hero3) this.commentObserver.observe(hero3);
  }

  ngOnDestroy(): void {
    this.commentObserver?.disconnect();
  }


  iniciarGuia(): void {
    this.guiaMockup = true;
    this.cdr.markForCheck();
  }

  abrirModal(): void {
    this.modalAberto = true;
    this.cdr.markForCheck();
  }

  fecharModal(): void {
    this.modalAberto = false;
    this.cdr.markForCheck();
  }

  onSliderChange(event: Event): void {
    this.sliderValue = +(event.target as HTMLInputElement).value;
    this.cdr.markForCheck();
  }

  onSliderWheel(event: WheelEvent): void {
    event.preventDefault();
    const delta = event.deltaY > 0 ? -3 : 3;
    this.sliderValue = Math.min(100, Math.max(0, this.sliderValue + delta));
    this.cdr.markForCheck();
  }

}
